import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDValuesSceneController {
    private readonly sidebarController: UISidebarController
    private readonly valuesSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.valuesSceneContainerDiv = document.getElementById('scene_discord_values_container') as HTMLDivElement
    }

    hide() {
        this.valuesSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.valuesSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
